import React from "react";
import Reveal from "./Reveal";
import { TESTIMONIALS } from "../../data/content";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="section-pad relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="overline mb-4">Partner Voices</div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight mb-14">
            What Partners <span className="text-amber">Say.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 0.1}
              className="relative rounded-xl border border-white/[0.07] bg-surface p-8"
            >
              <div className="font-display text-6xl text-amber/30 leading-none">&ldquo;</div>
              <p className="text-ink-secondary leading-relaxed -mt-4 mb-8">{t.text}</p>
              <div className="flex items-center gap-4">
                <div className="h-11 w-11 rounded-full bg-amber/15 text-amber flex items-center justify-center font-display font-bold">
                  {t.initials}
                </div>
                <div>
                  <div className="font-medium text-ink">{t.name}</div>
                  <div className="text-sm text-ink-muted">{t.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
